import { configureStore } from '@reduxjs/toolkit'
import appReducer from './appReducer'

export const StoreApp = configureStore({
  reducer: {
    app:appReducer
  },
})